export default __webpack_public_path__ + "static/media/avatar-team-women.193a559c.jpg";